import React, { useEffect, useState } from 'react';
import {
	ActiveCompaniesDocument,
	OfflineDriveCandidate,
	OfflineDriveCandidateStatus,
	// UserSkillRatingDocument,
} from 'types';
import { Avatar } from 'flowbite-react';
import { Tooltip, useMediaQuery } from '@mui/material';
import {
	// isScoreRangeValid,
	revertPositionTitleV2,
	stringAvatar,
} from 'shared-utils';
import { FaCheckCircle } from 'react-icons/fa';
import DisplayRoom from '../../DisplayRoom';
// import MatchPercentageCircularBar from 'src/components/university/MathPercentageCirularBar';
// import { badgesList } from 'src/components/profile/ProfileTechnicalScorecard';
import { LightTooltip } from 'src/components/recruiterPositions/RecruiterCandidateCardHeader';
// import { PiInfoFill } from 'react-icons/pi';
import { useThemeContext } from 'src/context/ThemeProvider';
import { getTimer, statusIcon } from '../CandidateCurrentStatus';
import CandidateActions from '../candidateActions/CandidateActions';
import { useUserContext } from 'src/context/UserProvider';
import dayjs from 'dayjs';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { Drawer } from 'src/components/shared/Drawer';
import OfflineDriveRoundStatusHistory from '../OfflineDriveRoundStatusHistory';

interface Props {
	candidate: OfflineDriveCandidate;
	bulkSelect: boolean;
	attendDriveDate: Date;
}

function MobileCardForOfflineDriveCandidate({ candidate, bulkSelect, attendDriveDate }: Props) {
	const { themeMode } = useThemeContext();
	const isMobile = useMediaQuery('(max-width:960px)');
	const [showStatusHistoryModal, setShowStatusHistoryModal] = useState(false);
	const { selectedDrive, bulkSelectIds, setBulkSelectIds } = useUserContext();

	const isSelected = bulkSelectIds.find(bulkCandidate => bulkCandidate?.toString() === candidate?._id?.toString())
		? true
		: false;

	// Score / skill level UI hidden (restore with table columns if needed)
	// const getBadgesWithSkills = (skillRatings: UserSkillRatingDocument[]) => {
	// 	const badgesWithSkills = badgesList.map(badge => {
	// 		const filteredSkills = (skillRatings?.length ? skillRatings || [] : []).filter(item => {
	// 			const score = isScoreRangeValid(Math.round(item.rating));
	// 			return score >= badge.minScore && score < badge.maxScore;
	// 		});
	// 		return { ...badge, skills: filteredSkills };
	// 	});
	// 	return badgesWithSkills
	// 		.sort((a, b) => b.minScore - a.minScore)
	// 		?.filter(el => el.skills.length)
	// 		.slice(0, 2);
	// };
	// const badeges = getBadgesWithSkills(candidate?.skillRatings);

	const [timer, setTimer] = useState('');
	const isNotAvailableForLong: number =
		candidate?.status === OfflineDriveCandidateStatus.BUSY || candidate?.status === OfflineDriveCandidateStatus.ASSIGN
			? dayjs().diff(
					dayjs(
						candidate.offlineDriveCandidateStatusHistory?.sort(
							(a, b) => dayjs(b.updatedAt).unix() - dayjs(a.updatedAt).unix(),
						)[0]?.updatedAt,
					),
					'minutes',
			  )
			: 0;

	useEffect(() => {
		if (candidate) {
			const interval = setInterval(() => {
				const updatedTimer = getTimer(
					candidate?.status as OfflineDriveCandidateStatus,
					candidate?.offlineDriveCandidateStatusHistory,
				);
				setTimer(updatedTimer);
			}, 1000);

			return () => clearInterval(interval);
		}
	}, [candidate]);

	return (
		<div
			className={`w-full border border-[#EBEBF0] rounded-[12px] bg-[#FFF] shadow-[0px_1px_2px_rgba(226,226,226,0.00),_0px_1px_3px_rgba(167,167,167,0.09)] flex flex-col box-border pt-4 relative ${
				bulkSelect ? 'cursor-pointer' : 'cursor-auto'
			}`}
			style={{
				backgroundColor: isNotAvailableForLong >= 60 ? 'rgba(255, 229, 229, 0.50)' : '',
			}}
			onClick={() => {
				if (bulkSelect && candidate?.status !== OfflineDriveCandidateStatus.HIRED) {
					if (isSelected) {
						setBulkSelectIds(prev =>
							prev.filter(bulkCandidate => bulkCandidate?.toString() !== candidate?._id?.toString()),
						);
						return;
					}
					setBulkSelectIds(prev => [...prev, candidate?._id?.toString()]);
				}
			}}
		>
			{bulkSelect ? (
				<FaRegCircleCheck
					className={`w-[24px] h-[24px] absolute right-[-7px] pointer-events-none ${
						isSelected ? 'bg-[#7777E7] text-[#CCDDFF]' : 'bg-white text-[#555770]'
					} rounded-full top-[-7px] `}
				/>
			) : null}
			<div className="flex justify-between px-4">
				<div className="flex flex-1 min-w-[80px] relative">
					<div className="flex items-start gap-2">
						<Avatar
							rounded
							theme={{
								root: {
									size: {
										md: 'h-12 w-12',
									},
								},
							}}
							img={candidate?.image || ''}
							className="text-xl flex max-w-[48px] max-h-[48px] min-w-[48px] min-h-[48px] h-full w-full"
							placeholderInitials={stringAvatar(
								candidate?.name?.trim()?.toUpperCase() || candidate?.email?.trim()?.toUpperCase(),
							)}
						/>

						<div className="flex gap-1 flex-col">
							<div className="flex items-center gap-1">
								<Tooltip title={candidate?.name} placement="top">
									{true ? (
										<a
											target="_blank"
											href={`${process.env.REACT_APP_APP_ENDPOINT}/profile/${candidate?.handler}?company=true`}
											className="cursor-pointer underline text-[18px] font-[600] text-[#1C1C28] flex items-center gap-1"
											rel="noreferrer"
										>
											<span className="capitalize">{candidate?.name?.toLowerCase()}</span>
										</a>
									) : (
										<p className="text-[#1C1C28] font-inter text-xl font-semibold leading-[120%] capitalize">
											{candidate?.name?.toLowerCase()}
										</p>
									)}
								</Tooltip>
								{candidate?.documents && candidate?.documents?.filter(e => e?.isAdminVerified).length > 0 ? (
									<Tooltip
										title={candidate?.documents
											?.filter(e => e?.isAdminVerified)
											?.map(document => document.documentType)
											.join(', ')}
										placement="top"
									>
										<div>
											<FaCheckCircle className="text-blue-500" />
										</div>
									</Tooltip>
								) : null}
							</div>
							<div className="flex gap-1 flex-col md:flex-row">
								<p className="text-[#555770] text-xs font-medium">
									{candidate?.phone} {candidate?.studentCode ? `(${candidate?.studentCode})` : ''}
								</p>
								<span className="text-[#8F90A6] text-xs font-medium font-inter leading-[16px] hidden md:inline">
									&bull;
								</span>

								{candidate?.email && (
									<LightTooltip
										placement="top"
										light={!(themeMode === 'dark')}
										title={
											<p className="text-[#28293D] text-xs font-medium p-1">
												<strong>Email:</strong> {candidate?.email}
											</p>
										}
									>
										<p className="text-[#28293D] text-xs font-medium max-w-[120px] truncate md:truncate-none md:max-w-[250px]">
											{candidate?.email}
										</p>
									</LightTooltip>
								)}
								{attendDriveDate ? (
									<LightTooltip
										placement="top"
										light={!(themeMode === 'dark')}
										title={
											<p className="text-[#28293D] text-xs font-medium p-1">
												<strong>Registered At: </strong>
												{attendDriveDate ? dayjs(attendDriveDate).format('Do MMM YYYY, hh:mm A') : '-'}
											</p>
										}
									>
										<p className="text-[#28293D] font-inter text-xs font-medium max-w-[120px] truncate md:truncate-none md:max-w-[250px]">
											{attendDriveDate ? dayjs(attendDriveDate).format('Do MMM YYYY, hh:mm A') : '-'}
										</p>
									</LightTooltip>
								) : null}
							</div>
						</div>
					</div>
				</div>
				{/* Score gauge (desktop table column commented out; restore with MatchPercentageCircularBar import) */}
				{/* <div className="w-[70px] m-auto flex justify-center items-center">
					<MatchPercentageCircularBar value={Math.round(candidate?.score || 0)} />
				</div> */}
			</div>
			<div className="py-2.5 flex flex-col gap-2.5 px-4">
				{candidate?.activeCompanies.length ? (
					<div className="flex flex-col gap-0.5">
						<p className="text-[#555770] text-[10px] font-medium">Active Companies</p>
						<div className="flex flex-col gap-1 text-[#1F3343]">
							{candidate?.activeCompanies.length ? (
								candidate?.activeCompanies.map((activeCompany: ActiveCompaniesDocument, index: number) => {
									return (
										<p key={index} className="font-inter text-xs font-medium ">
											{activeCompany?.companyName} - {revertPositionTitleV2(activeCompany?.positionTitle)}
										</p>
									);
								})
							) : (
								<p className="text-center"> - </p>
							)}
						</div>
					</div>
				) : null}

				{/* Skill level badges (desktop table column commented out; restore with getBadgesWithSkills / badeges) */}
				{/* <div className="flex-1 w-full col-span-2">
					<Label className="text-[10px] text-[#555770] flex gap-1 items-center mb-1">
						Skills{' '}
						<span className="text-[12px]">
							<LightTooltip
								light={!(themeMode === 'dark')}
								title={
									<div className="p-2 text-sm text-center text-[#555770] font-[500]">
										<p>Skill Level" indicates the competency level of the candidates in the relevant skills</p>
									</div>
								}
								placement="bottom-end"
								arrow={true}
								componentsProps={{
									tooltip: {
										sx: {
											border: '0px !important',
											borderRadius: '4px !important',
											boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
										},
									},
								}}
							>
								<span>
									<PiInfoFill />
								</span>
							</LightTooltip>
						</span>
					</Label>
					{!badeges?.length ? (
						<div className="text-xs text-[#555770]">N/A</div>
					) : (
						<div className="flex gap-[18px] text-center ">
							{badeges?.map((badege, index) => (
								<div key={index} className="flex gap-[3px]">
									<div
										className="flex items-center gap-1 text-sm rounded-[6px] px-2 py-[1px]"
										style={{ background: badege?.bg, color: badege?.text }}
									>
										<img src={badege?.icon} alt="" className="max-w-[15px] max-h-[15px]" />
										{badege?.title}
									</div>
									{badege?.skills?.length ? (
										<Tooltip
											title={
												<div className="text-center">
													{badege?.skills?.map(skill => skill?.skill?.name)?.join(', ')}
												</div>
											}
											arrow
											placement="bottom"
										>
											<div className="flex justify-center border-b border-[#555770] mx-auto border-dashed h-fit w-fit text-center text-[11.2px] font-[500] text-[#555770]">
												{badege?.skills?.length ? `${badege?.skills?.length} skills` : ''}
											</div>
										</Tooltip>
									) : null}
								</div>
							))}
						</div>
					)}
				</div> */}
			</div>
			<div
				className="inline-flex p-[7px_10.73px_6px_15px] justify-between items-center gap-9 rounded-b-[12px] border-t-[1px] border-t-[#EBEBF0] "
				style={{
					backgroundColor: isNotAvailableForLong >= 60 ? 'rgba(255, 229, 229, 0.50)' : 'bg-[#FAFAFC]',
				}}
			>
				<div className="flex flex-col">
					<div className="flex gap-2 items-center" onClick={() => setShowStatusHistoryModal(true)}>
						<div className="flex gap-1.5 items-center">
							<div>{statusIcon(candidate?.status as OfflineDriveCandidateStatus)}</div>
							<p className="text-[#28293D] text-sm font-medium">
								{// move underscore and capitalize first letter
								candidate?.status
									.replace(/_/g, ' ')
									.split(' ')
									.map(word => word.charAt(0).toUpperCase() + word.slice(1))
									.join(' ')}
							</p>
						</div>
						<div>
							{candidate?.status === OfflineDriveCandidateStatus.BUSY ||
							candidate?.status === OfflineDriveCandidateStatus.ASSIGN ? (
								<div className="flex items-center gap-[3.2px] p-[1.6px_3.2px] rounded-[3.2px] border-[0.5px] border-[#FDAC42] bg-[#FFF8E5]">
									<img src="/assets/ClockCountdown.svg" alt="timer" className="w-3 h-3" />
									<p className="text-[#28293D] text-center font-inter text-[9.6px] font-normal whitespace-pre">
										{timer}
									</p>
								</div>
							) : null}
						</div>
					</div>
					<div>
						<DisplayRoom offlineDriveRoom={candidate?.offlineDriveRoom} status={candidate?.status} />
					</div>
				</div>
				<div>
					<CandidateActions driveId={selectedDrive?.value || ''} candidate={candidate} />
				</div>
			</div>

			<Drawer
				minHeight="auto"
				fullWidth={true}
				isModal={!isMobile}
				isOpen={showStatusHistoryModal}
				onClose={() => setShowStatusHistoryModal(false)}
				header={
					<div className="p-3 pb-0">
						<strong className="text-lg capitalize">{candidate?.name?.toLowerCase()}'s</strong>{' '}
						<span className="text-lg font-[400] text-[#1F3343]">status history</span>
					</div>
				}
				body={
					<div className="p-3">
						<OfflineDriveRoundStatusHistory
							offlineDriveCandidateStatusHistory={candidate?.offlineDriveCandidateStatusHistory}
						/>
					</div>
				}
			/>
		</div>
	);
}

export default MobileCardForOfflineDriveCandidate;
